/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";
import useProfile from "../../../hooks/useProfile";
const AddRemarks = () => {
  const [userData] = useProfile();
  // console.log(userData);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();

  const { data: remarkInfo = [],refetch } = useQuery({
    queryKey: ["remarkInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-remarks`
      );
      const data = await res.json();
      return data;
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    
    formData.append("REMARKS_NAME", data.remarks_name);
    formData.append("CREATED_BY", userData.username);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/remarks-create`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Remark Add successful", {
            position: toast.POSITION.TOP_CENTER
          });
          refetch().then(() => {
            dispatch(handleAddClose());
          });
        } else if (data.duplicate === true) {
          toast.error("This Remark is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p='20px'>
      <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          label="Remarks Name*"
          variant="outlined"
          {...register("remarks_name", { required: true })}
        />
        {errors?.remarks_name?.type === "required" && (
          <ErrorMessage>Remarks Name is required*</ErrorMessage>
        )}
      </Box>

      {/* <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          label=" created By*"
          variant="outlined"
          {...register("created_by", { required: true })}
        />
        {errors?.created_by?.type === "required" && (
          <ErrorMessage>Created by name is required*</ErrorMessage>
        )}
      </Box> */}
      </Box>

     
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Add Remark
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box>

    </form>
  );
};

export default AddRemarks;
